import { StudyEntityType, SystemOptionsByAssessmentMeasurementId } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { studyAssessmentMeasurementSystemOptionsClient } from './StudyAssessmentMeasurementSystemOptionsClient';

const factory = createStudyEntityHookFactory<SystemOptionsByAssessmentMeasurementId>(
    'StudyAssessmentMeasurementSystemOption'
);

export const useStudyAssessmentMeasurementSystemOptions = factory.list(
    studyAssessmentMeasurementSystemOptionsClient.listAllStudyAssessmentMeasurementSystemOptions,
    [StudyEntityType.StudyAssessmentMeasurement]
);
